import _ from 'lodash';
/**
 * @param {Int16Array} result
 * @param {object} settings
 * @returns
 */
export function getInspectionResutlColor(result, settings, notInspect = false) {
  const symbol = getInspectionResutlSymbol(result, settings, notInspect);
  if (symbol === "") {
    return "";
  }
  if (_.isEmpty(settings)) {
    return "";
  }
  if (result === 1) {
    return settings.passed.color;
  }
  if (result === 0) {
    return settings.failed.color;
  }
  if (result === 2 || result === -1) {
    if (result === -1 && notInspect) {
      return settings.not_inspected.color;
    }
    return settings.other_okng.color;
  }
  if (result === 3) {
    return settings.treatment_completed.color;
  }
  return settings.not_inspected.color;
}

/**
 * @param {Int16Array} result
 * @param {object} settings
 * @returns
 */
export function getInspectionResutlBackground(result, settings, notInspect = false, allowedWhite = false) {
  const symbol = getInspectionResutlSymbol(result, settings, notInspect);
  if (symbol === "") {
    return "";
  }
  if (_.isEmpty(settings)) {
    return '';
  }
  let resultKey = 'not_inspected';
  if (result === 1) {
    resultKey = 'passed';
  }
  if (result === 0) {
    resultKey = 'failed';
  }
  if (result === 2 || result === -1) {
    resultKey = 'other_okng';
    if (result === -1 && notInspect) {
      resultKey = "not_inspected";
    }
  }
  if (result === 3) {
    resultKey = 'treatment_completed';
  }
  if (allowedWhite || settings[resultKey].background.toLowerCase() !== "#ffffff") {
    return settings[resultKey].background;
  }
  return '';
}

/**
 * @param {Int16Array} result
 * @param {object} settings
 * @returns
 */
export function getInspectionResutlSymbol(result, settings, notInspect = false) {
  if (_.isEmpty(settings)) {
    return '';
  }
  let resultKey = 'not_inspected';
  if (result === 1) {
    resultKey = 'passed';
  }
  if (result === 0) {
    resultKey = 'failed';
  }
  if (result === 2 || result === -1) {
    resultKey = 'other_okng';
    if (result === -1 && notInspect) {
      resultKey = "not_inspected";
    }
  }
  if (result === 3) {
    resultKey = 'treatment_completed';
  }
  return settings[resultKey].symbol;
}

/**
 * @param {string} value
 * @param {int} boundaryType
 * @param {string} unit
 * @param {string} type
 * @returns
 */
export function getInspectionJudgment(value, boundaryType, unit, type) {
  if (_.isEmpty(value)) {
    return '-';
  }
  if (_.isEmpty(unit)) {
    unit = '';
  }
  let boundaryTypeJP = '';
  if (boundaryType === 1) {
    boundaryTypeJP = type === 'upper' ? '以下' : '以上'
  } else {
    boundaryTypeJP = type === 'upper' ? '未満' : '超過'
  }
  return value + unit + boundaryTypeJP
}

/**
 * @param {string} unit
 * @param {boolean} symbol
 * @returns
 */
export function getInspectionUnit(unit, symbol=false) {
  let newUnit = "";
  if (!_.isEmpty(unit)) {
    newUnit = unit.length > 9 ? unit.slice(0, 9) + "..." : unit;
  }
  if (symbol && newUnit !== "") {
    newUnit = "(" + newUnit + ")";
  }
  return newUnit
}

/**
 * @param {Int16Array} result
 * @param {object} settings
 * @returns
 */
export function getJudgmentResultColor(result, settings) {
  if (_.isEmpty(settings)) {
    return '';
  }
  if (Number(result) === 1) {
    return settings.passed.color;
  }
  if (Number(result) === 0) {
    return settings.failed.color;
  }
}

/**
 * @param {Int16Array} result
 * @param {object} settings
 * @returns
 */
export function getJudgmentResultBackground(result, settings) {
  if (_.isEmpty(settings)) {
    return '';
  }
  let resultKey = 'failed';
  if (Number(result) === 1) {
    resultKey = 'passed';
  }
  if (settings[resultKey].background.toLowerCase() !== "#ffffff") {
    return settings[resultKey].background
  }
  return '';
}

/**
 * @param {Int16Array} result
 * @param {object} settings
 * @returns
 */
export function getJudgmentResultSymbol(result, settings) {
  if (_.isEmpty(settings)) {
    return '';
  }
  let resultKey = 'failed';
  if (Number(result) === 1) {
    resultKey = 'passed';
  }
  return settings[resultKey].symbol;
}

/**
 * @param {Int16Array} settingsSymbol
 * @param {string} symbolKey
 * @returns
 */
export function getBackgroundSymbol(settings, symbolKey) {
  if (_.isEmpty(settings)) {
    return '';
  }
  const bgSymbol = settings[symbolKey].background;
  if (
    bgSymbol === "#FFFFFF" ||
    bgSymbol === "#ffffff" ||
    bgSymbol === "#FFF" ||
    bgSymbol === "#fff" ||
    bgSymbol === "rgb(255, 255, 255)" ||
    bgSymbol === "white"
  ) {
    return 'transparent'
  }
  return bgSymbol;
}

/**
 * @param {Int16Array} result
 * @param {string} settings
 * @returns
 */
export function getInspectionRowBackground(result, settings) {
  if (_.isEmpty(settings)) {
    return '';
  }
  if (
    settings['failed'].background.toLowerCase() !== "#ffffff" ||
    settings['passed'].background.toLowerCase() !== "#ffffff" ||
    settings['other_okng'].background.toLowerCase() !== "#ffffff"
  ) {
    return getInspectionResutlBackground(result, settings)
  }
  return '';
}

/**
 * @param {object} user
 * @returns
 */
export function formatUserDisplay(user) {
  if (_.isEmpty(user)) {
    return '';
  }

  return `${user.name} (${user.username})`;
}
